export const CONTENT_SOURCE = {
    AEM_CLOUD: 'aemCloud',
    S3: 's3',
    AEM_SDK: 'aemSdk',
} as const;

export type ContentSource = (typeof CONTENT_SOURCE)[keyof typeof CONTENT_SOURCE];

const hasQueryParam = (name: string) => new URLSearchParams(window.location.search).has(name);

/**
 * Content source priority:
 * 1. ?aemCloud - AEM Cloud (/wam-consumer), ignores S3
 * 2. ?testContent or qa env - S3
 * 3. Default - AEM SDK (/graphql)
 *
 * To enable AEM Cloud locally, add to the app env file:
 *   VITE_AEM_AUTH_COOKIE_NAME=Auth-Custom-Edge-STG
 *   VITE_AEM_AUTH_COOKIE_VALUE=<token>
 *   AEM_REMOTE_HOST=https://www.stg.iqos.com
 */
export const getContentSource = (): ContentSource => {
    if (hasQueryParam('aemCloud')) return CONTENT_SOURCE.AEM_CLOUD;
    if (hasQueryParam('testContent') || import.meta.env.VITE_ENV === 'qa') return CONTENT_SOURCE.S3;
    return CONTENT_SOURCE.AEM_SDK;
};
